import React, { Component } from 'react'
import { connect } from "react-redux";
import classnames from "classnames";
import { get } from 'lodash'
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';
import { profileUpdateStages } from '../store/profile/actions'
import { SHORT_SUBJECT_TYPE } from '../constants/subjectTypes'

import tracker from "./../tracker";
import { SUBJECTS1, SUBJECTS2, SUB_SUBJECT } from './../constants/subjectTypes';
import { namespace } from './../config';

import TooltipSubjects from './shared/TooltipSubjects';
import Button from './shared/Button';
import Checkbox from './shared/Checkbox';

import baseStyles from 'custom/base.styl';
import gridStyles from './../styles/grid.styl';

class PageSecondarySubjects extends Component {
  constructor(props) {
    super(props)

    this.state = {
      second_subjects: [],
      idSubject: null,
    }

    this.onChange = this.onChange.bind(this);
    this.renderElement = this.renderElement.bind(this);
    this._handleOnClickUpdateStages = this._handleOnClickUpdateStages.bind(this);
  }

  onChange(s) {
    const { second_subjects } = this.state;
    const newValue = second_subjects.indexOf(s) > -1 ? second_subjects.filter(sb => sb !== s) : [...second_subjects, s];

    this.setState({
      second_subjects: newValue,
      idSubject: s,
    });
  }

  setApplicationData(payload) {
    const { profileId } = this.props;
    const key = `${namespace}-${profileId}`;
    tracker.store.set(key, payload).then(res => console.log(res.ok)).catch(error => {
      console.error('Error set application form:', error)
    });
    return;
  }

  _handleOnClickUpdateStages() {
    const { profileAppForm, profileStage, profileId, version, subjectType } = this.props;
    const { second_subjects } = this.state;
    const data = { ...profileAppForm, second_subjects, subjects: [...profileAppForm.major_subjects, ...second_subjects] }
    this.setApplicationData(data);
    const trackData = { userId: profileId, version, site_id: trackSiteId, preferredSubject: SHORT_SUBJECT_TYPE[subjectType], secondSubjects: second_subjects.join(', ') }

    trackValues('stage', profileStage, {
      context: trackData,
    });

    this.props.profileUpdateStages(data);
  }

  renderItem(s) {
    const { profileAppForm } = this.props;
    const { second_subjects, idSubject } = this.state;
    const isMajorSubj = profileAppForm && (profileAppForm.major_subjects || []).indexOf(s) > -1;
    const checked = (second_subjects && second_subjects.indexOf(s) > -1) || isMajorSubj || false;
    const isDisabled = isMajorSubj || (second_subjects && second_subjects.length === 2 && !checked) || false;

    return (
      <div>
        <Checkbox
          checked={checked}
          onChange={() => this.onChange(s)}
          key={`subj_${s}`}
          disabled={isDisabled}
          className={classnames(baseStyles.block, baseStyles.subject_checkbox, { [baseStyles.custom_disabled]: isDisabled })}
        >
          {s}
        </Checkbox>
        {idSubject === s &&
          <ul className={classnames(baseStyles.tooltip_box_mobile, { [baseStyles.active]: checked })}>
            {SUB_SUBJECT[s].map(s => <li key={s}>{s}</li>)}
          </ul>
        }
      </div>
    );
  }

  renderElement(s, positionLeft = false, positionRight = false) {
    return (
      <TooltipSubjects
        key={s}
        containerClass={classnames(baseStyles.tooltip_box, baseStyles.tooltip_subjects, { [baseStyles.tooltip_subjects_right]: positionRight })}
        renderContent={() => this.renderItem(s)}
        positionLeft={positionLeft}
        positionRight={positionRight}
      >
        <ul>
          {SUB_SUBJECT[s].map(s => <li key={s}>{s}</li>)}
        </ul>
      </TooltipSubjects>
    );
  }

  render() {
    const { second_subjects } = this.state;
    const isDisabledButton = second_subjects && second_subjects.length < 2;
    return (
      <div>
        <div className={baseStyles.header}>
          <h2 className={baseStyles.title}>Application form!</h2>
        </div>
        <p className={baseStyles.subtitle_type2}>We use this information to recommend you orders in your preferred subjects</p>

        <div className={classnames(baseStyles.content_board, baseStyles.centered, baseStyles.content_wide)}>
          <div className={baseStyles.subtitle_type3}>Choose two more subject categories you also <br /> consider working on:</div>

          <div className={classnames(gridStyles.row, baseStyles.space_bottom_large, baseStyles.xs_block)}>
            <div className={classnames(gridStyles.col_6, baseStyles.left)}>
              {SUBJECTS1.map(s => this.renderElement(s, true))}
            </div>
            <div className={classnames(gridStyles.col_6, baseStyles.left)}>
              {SUBJECTS2.map(s => this.renderElement(s, false, true))}
            </div>
          </div>
          <Button disabled={isDisabledButton || this.props.isFetching} onClick={this._handleOnClickUpdateStages}>Submit</Button>
        </div>
      </div>
    )
  }
};

const mapStateToProps = state => {
  const profile = state.profile;
  const isFetching = (profile && profile.isFetching) || false;
  const profileId = get(profile.data, 'user.id');
  const profileStage = get(profile.data, 'user.stage');
  const version = get(profile.data, 'user.scenario_version');
  const profileAppForm = get(profile.data, 'user.profile.applicant_info');
  const subjectType = get(profile.data, 'user.profile.subject_type');

  return {
    isFetching,
    profileAppForm,
    profileId,
    profileStage,
    version,
    subjectType,
  }
};

const mapDispatchToprops = dispatch => ({
  profileUpdateStages: (data) => (dispatch(profileUpdateStages(data))),
});

export default connect(mapStateToProps, mapDispatchToprops)(PageSecondarySubjects);



// WEBPACK FOOTER //
// ./src/components/PageSecondarySubjects.js